import { useAuth } from '@/shared/lib/auth';
import { initials } from '@/shared/lib/format';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card';
import { Avatar, AvatarFallback } from '@/shared/ui/avatar';
import { Badge } from '@/shared/ui/badge';

export function AccountProfilePage() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <Card className="max-w-xl">
      <CardHeader>
        <CardTitle>Perfil</CardTitle>
      </CardHeader>
      <CardContent className="flex items-center gap-4">
        <Avatar className="size-14 text-base">
          <AvatarFallback>{initials(user.name)}</AvatarFallback>
        </Avatar>
        <div className="min-w-0">
          <p className="truncate text-lg font-semibold">{user.name}</p>
          <p className="truncate text-sm text-muted-foreground">{user.email}</p>
          <Badge variant="secondary" className="mt-2">{user.role}</Badge>
        </div>
      </CardContent>
    </Card>
  );
}
